/**
 * @fileoverview Agent definition for world-object-ideation-v3.
 *
 * This agent generates ideas for significant objects (artifacts, items, outfits)
 * that could appear in the story world.
 *
 * @category world-building.objects.creation
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'world-object-ideation-v3',
  kind: 'primitive',
  name: 'World Object Ideation',
  description: 'Generates ideas for significant objects (artifacts, items, outfits) in your story world.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    taxonomyPath: 'world-building.objects.creation',
    usedBy: [
      'use-world-object-ideation-v3.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'world-object-details-ideation-v3',
      'world-object-details-generator-v3',
    ],
  },
};
